import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { LoginRequest, Session } from '@manaro/contracts'
import { ApiError } from '@/shared/api/client.ts'
import { queryKeys } from '@/shared/api/query-keys.ts'
import * as api from './api.ts'

export function useSession() {
  return useQuery({
    queryKey: queryKeys.session,
    queryFn: ({ signal }) => api.fetchSession(signal),
    retry: (_count, error) => !(error instanceof ApiError && error.isUnauthorized),
    staleTime: 5 * 60 * 1000,
  })
}

export function useLogin() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: LoginRequest) => api.login(payload),
    onSuccess: (session: Session) => {
      queryClient.setQueryData(queryKeys.session, session)
    },
  })
}

export function useLogout() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: api.logout,
    onSettled: () => queryClient.clear(),
  })
}
